import { render } from "./IconoCocktail.vue?vue&type=template&id=75a87da2"
import script from "./IconoCocktail.vue?vue&type=script&lang=js"
export * from "./IconoCocktail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__